<nav mat-tab-nav-bar>
  <a
    mat-tab-link
    routerLink="/style-guide/typography"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive">
    Typography
  </a>
  <a
    mat-tab-link
    routerLink="/style-guide/button"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive">
    Button
  </a>
  <a
    mat-tab-link
    routerLink="/style-guide/input"
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive">
    Input
  </a>
  <a
    mat-tab-link
    routerLink="/style-guide/icon"
    routerLinkActive
    #rla4="routerLinkActive"
    [active]="rla4.isActive">
    Icon
  </a>
</nav>
